// src/redux/slices/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Async thunk to update user password
export const updatePassword = createAsyncThunk(
    "user/updatePassword",
    async (params, { rejectWithValue }) => {
        try {
            // old behavior: PUT with /id
            const response = await agent.put(`${API.UPDATE_PASSWORD}/${params.id}`, params);

            if (response.status === 200) {
                // Clear local storage (same as old code)
                localStorage.setItem("authToken", "");
                localStorage.removeItem("userToken");
                localStorage.removeItem("token");
                localStorage.removeItem("profileImage");
                localStorage.removeItem("persist:root");
                localStorage.removeItem("profile_img");
                localStorage.removeItem("mentorEligibilityPopupShown");

                return {
                    success: true,
                    message: response.data?.message || "Password updated successfully",
                };
            } else {
                return rejectWithValue({
                    success: false,
                    message: response.data?.message || "Something went wrong",
                });
            }
        } catch (error) {
            return rejectWithValue({
                success: false,
                message: error.message || "Something went wrong",
            });
        }
    }
);

// Optionally, load current user info
export const fetchUserInfo = createAsyncThunk(
    "user/fetchUserInfo",
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.get(`${API.GETUSERDATA}`);
            return response.data?.data || {};
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const passwordSlice = createSlice({
    name: "password",
    initialState: {
        userInfo: null,
        loading: false,
        error: null,
        updatePasswordResult: null, // for showing success message
    },
    reducers: {
        clearUpdatePasswordResult(state) {
            state.updatePasswordResult = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch user info
            .addCase(fetchUserInfo.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUserInfo.fulfilled, (state, action) => {
                state.userInfo = action.payload;
                state.loading = false;
            })
            .addCase(fetchUserInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updatePassword.pending, (state) => {
                state.loading = true;
                state.updatePasswordResult = null;
            })
            .addCase(updatePassword.fulfilled, (state, action) => {
                state.loading = false;
                state.updatePasswordResult = action.payload;
            })
            .addCase(updatePassword.rejected, (state, action) => {
                state.loading = false;
                state.updatePasswordResult = action.payload;
            });
    },
});

export const { clearUpdatePasswordResult } = passwordSlice.actions;
export default passwordSlice.reducer;
